import { Button, Typography } from '@packages/shared';
import type { GlycerinButtonClickPayload } from '@packages/tracking/src/types/payloads';

export interface InstallmentValueTileProps {
  /**
   * the installment value to display
   */
  value: number;
  /**
   * should the tile styled as an active one
   */
  active: boolean;
  /**
   * on click handler function
   */
  onClickHandler: (value: number) => void;
  /**
   * tracking props, when button is clicked
   */
  clickTrackingProps?: GlycerinButtonClickPayload;
}

const tileSize = '2.75rem';

/**
 * installment value tile
 *
 * displays a single installment value
 *
 * */
export const InstallmentValueTile = ({
  value,
  active,
  onClickHandler,
  clickTrackingProps,
}: InstallmentValueTileProps) => (
  <Button
    clickTrackingProps={clickTrackingProps}
    sx={{
      width: tileSize,
      height: tileSize,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    color={active ? 'primary' : 'inherit'}
    onClick={() => {
      if (!active) {
        onClickHandler(value);
      }
    }}
  >
    <Typography variant="body1" sx={{ wordBreak: 'normal' }}>
      {value}
    </Typography>
  </Button>
);
